import React, { useState, useRef } from 'react'
import {
  Box, Text, ImageLoader, KeyboardArrowDownIcon, KeyboardArrowUpIcon,
} from '@usap/uicomponents'
import {
  ImageUploadBox,
  ToggleBox,
  ToggleText,
  ImageUploadIcon,
} from '../style/ImageUpload.css'

const ImageUploads = ({
  sku, selectedImages, isDesktop, filesUpload,
}) => {
  const toggleButtons = useRef({ })
  const [arrowIcon, setArrowIcon] = useState(KeyboardArrowDownIcon)
  const [showText, setShowText] = useState('Show more details')

  if (!selectedImages || !selectedImages[`${sku}`]) return null
  if (!Array.isArray(selectedImages[`${sku}`]) && selectedImages[`${sku}`].length < 1) return null

  const setShow = curRef => {
    const ref = curRef
    if (ref.style.display === 'none') {
      ref.style.display = 'flex'
      ref.style.height = 'auto'
      ref.style.transition = 'unset'

      setArrowIcon(KeyboardArrowUpIcon)
      setShowText('Show less details')
    } else {
      ref.style.display = 'none'
      ref.style.height = '0'
      ref.style.transition = 'height 350ms ease-in-out'

      setArrowIcon(KeyboardArrowDownIcon)
      setShowText('Show more details')
    }
  }

  const selectedImage = selectedImages[`${sku}`]
  const filesUploads = filesUpload[`${sku}`]

  /* filter uploaded files excluding deleted and non-photo upload */
  const correctRegex = new RegExp(/file-/i)
  const newFilterData = {}

  Object.keys(selectedImage)
    .filter(elem => Object.keys(filesUploads).includes(elem) && !correctRegex.test(elem))
    // eslint-disable-next-line array-callback-return
    .map(element => {
      newFilterData[`${element}`] = selectedImage[`${element}`]
    })

  const displayUpload = fileItem => {
    const mimeType = newFilterData[`${fileItem}`].type
    if (mimeType.includes('image')) {
      return (
        <ImageLoader
          key={`image${sku}`}
          layout="fixed"
          height="68px"
          width="68px"
          fit="cover"
          src={newFilterData[`${fileItem}`].file}
          alt={newFilterData[`${fileItem}`].id}
          cloudinaryParams="w_100,h_80"
        />
      )
    }
    return (
      <Text>{newFilterData[`${fileItem}`].id}</Text>
    )
  }

  return (
    <>
      <Box width="100%">
        <ImageUploadBox
          key={`holder${sku}`}
          ref={ref => { toggleButtons.current[`${sku}`] = ref }}
        >
          {Object.keys(newFilterData).map(photo => (
            <Box
              key={`imageHolder${sku}-${photo}`}
              margin={isDesktop ? '2px' : '8px'}
              height="68px"
              width="68px"
            >
              { displayUpload(photo) }
            </Box>
          ))}
        </ImageUploadBox>
        <ToggleBox onClick={() => setShow(toggleButtons.current[`${sku}`])}>
          <ToggleText>
            {showText}
            <ImageUploadIcon icon={arrowIcon} />
          </ToggleText>
        </ToggleBox>
      </Box>
    </>
  )
}

export default ImageUploads
